import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  formFieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    marginTop: theme.spacing(1),
  },

  fieldsContainer: {
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    columnGap: '24px',
  },
  field: {
    width: '311.78px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
    marginTop: theme.spacing(3),
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionSubHeading: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  contentHeading: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  fieldsContainerAutoComplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    textAlign: 'left',
    marginTop: theme.spacing(3),
  },
  fieldWidth: {
    width: '497px',
  },
  subHeading: {
    fontFamily: `${theme.typography.fontFamily} !important`,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: ' 20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
  },
  alertInfoHeading: {
    marginBottom: theme.spacing(1.25),
    fontWeight: 500,
    letterSpacing: '0.1px',
    lineHeight: '20px',
    color: theme.palette.labraText.tertiary,
  },
  alertInfoSubHeading: {
    fontFamily: theme.typography.fontFamily,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
  },
  alertInfoLinkText: {
    color: theme.palette.select.light,
    fontFamily: theme.typography.fontFamily,
    textDecoration: 'none',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    marginTop: theme.spacing(1.25),
  },
  partnershipTypeContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  checkboxContainer: {
    display: 'flex',
  },
  checkbox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  checkboxLabel: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: theme.palette.labraText.primary,
  },
  checkboxSupportText: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.secondaryDescription,
  },
}))
